<template>
  <div>
    <div class="maincontainer mt-4">
      <b-row>
        <b-col class="py-4 mb-2">
          <b-form-group class="subtitles1">
            <router-link :to="{ name: 'Dashboard' }">
              <h5 class="back">
                &#x2190; Confirm Details For Manuel philip Anto M.K
              </h5>
            </router-link>
          </b-form-group>
        </b-col>

        <b-col class="py-4 mb-3 text-right">
          <b-form-group>
            <h5 class="next" @click="Offerletterdetails">
              Next Step: <i style="font-size: 15px" class="fas">&#xf054;</i>
            </h5>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- <hr> -->

      <b-row>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-2"
            label="First Name*:"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              disabled
              v-model="offerletter.firstName"
              placeholder="Enter First name"
              class="form_input"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-2"
            label="Middle Name:"
            label-for="input-2"
          >
            <b-form-input
              disabled
              id="input-2"
              v-model="offerletter.middleName"
              placeholder="Enter Middle name"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-2"
            label="Last Name*:"
            label-for="input-2"
          >
            <b-form-input
              disabled
              id="input-2"
              v-model="offerletter.lastName"
              placeholder="Enter Last name"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Email Address*:"
            label-for="input-1"
          >
            <b-form-input
              disabled
              id="input-1"
              v-model="offerletter.email"
              type="email"
              placeholder="Enter email"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Contact Number*:"
            label-for="input-1"
          >
            <b-form-input
              disabled
              id="input-1"
              v-model="offerletter.phoneNumber"
              type="text"
              placeholder="Contact Number"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Date Of Birth*:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              disabled
              v-model="offerletter.dateOfBirth"
              type="date"
              placeholder="Date Of Birth"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Date Of Joining*:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              disabled
              v-model="offerletter.dateOfJoining"
              type="date"
              placeholder="Date Of Joining"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-3"
            label="Job Type*:"
            label-for="input-3"
          >
            <b-form-select
              id="input-3"
              disabled
              v-model="offerletter.JobType"
              :options="JobTypeoptions"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="OfferedCTC*:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              disabled
              v-model="offerletter.offeredCTC"
              type="number"
              placeholder="Offered CTC"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-2"
            label="Employer Address*:"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              disabled
              v-model="offerletter.employerAddress"
              placeholder="Employer Address"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-3"
            label="Department*:"
            label-for="input-3"
          >
            <b-form-select
              id="input-3"
              disabled
              v-model="offerletter.department"
              :options="Departments"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-8"
            label="Designation*:"
            label-for="input-8"
          >
            <b-form-select
              id="input-8"
              disabled
              v-model="offerletter.designation"
              :options="Designations"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-8"
            label="Job Description*:"
            label-for="input-8"
          >
            <b-form-textarea
              disabled
              id="textarea-rows"
              placeholder="Enter here"
              v-model="offerletter.jobDescription"
              rows="8"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <br />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ViewCandidateOfferDetails",
  data() {
    return {
      allselectedcand: [],
      offerletter: {
        candidateID: "",
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        dateOfBirth: "",
        dateOfJoining: "",
        JobType: null,
        offeredCTC: "",
        employerAddress: "",
        department: null,
        designation: null,
        jobDescription: "",
      },

      JobTypeoptions: [
        { text: "Select One", value: null },
        "Fulltime",
        "Contract",
      ],

      Departments: [
        { text: "Select One", value: null },
        "Information  Technology",
        "Devops",
      ],
      Designations: [
        { text: "Select One", value: null },
        "Intern",
        "Assosciate software Engineer",
        "Software Engineer",
        "Team Lead",
      ],
    };
  },
  computed: {
    ...mapGetters("hrPortalReferenceVUEX", {
      selectCandidate: "saveSelectCandidate",
    }),
  },
  created() {
    this.offerletter = this.selectCandidate;
  },
  methods: {
    Offerletterdetails() {
      this.$router.push({
        name: "TemplatesOfferLetter",
        params: { candidateID: this.offerletter.RecCandidateID },
      });
    },
  },
};
</script>

<style scoped>
.maincontainer {
  width: 90vw;
  margin-left: 2.5em;
  padding: 25px;
  height: 75vh;
  overflow-y: auto;
}
</style>
